/*
<button type="button" class="js-display-popin" data-target="#popin_IDUNIQUE">
	open popin
</button>

<div id="popin_IDUNIQUE" class="popin js-popin">
	<div class="popin__overlay js-popin-close"></div>	
    <div class="popin__container inner js-popin-content">
        <button type="button" class="popin__close js-popin-close">
            <svg class="icon icon-close popin__close-svg" aria-hidden="true"><use xlink:href="#icon-close" /></svg>
        </button>
        <div class="popin__content">
        	<div class="popin__title">titre popin</div>
        </div>
    </div><!-- popin__container -->
</div><!-- popin -->
*/
const popinProductPreview = require("./popinProductPreview");
var popin = {

	ui: {},

	init: function() {
		this.bindUI();
		this.bindEvents();

		const urlParams = new URLSearchParams(document.location.search);
		const openPopinID = urlParams.get("openPopin");
		if(openPopinID){
			$(".js-display-popin[data-target='#"+openPopinID+"']").click();
		}
	},

	bindUI: function() {
		this.ui.displayPopin_selector = ".js-display-popin";
		this.ui.popinClose_selector = ".js-popin-close";
		this.ui.updateAjaxTarget_selector = ".js-popin-update-ajax";
	},

	bindEvents: function() {
		$("body").on('click', this.ui.displayPopin_selector, this.popinOpen.bind(this));
		$("body").on('click', this.ui.popinClose_selector, this.popinClose.bind(this));
		$("body").on('click', this.ui.updateAjaxTarget_selector, this.popinUpdateAjax.bind(this));
	},

	popinContentClick: function(e) {
		e.stopPropagation();
	},
	popinOpen: function(e) {
		e.stopImmediatePropagation();
		let self = this;
		let $this = $(e.target);
		if(!$this.hasClass("js-display-popin")){
			$this = $this.closest('.js-display-popin');
		}
		let $target = $($this.attr('data-target'));
		e.preventDefault();
		$target.fadeIn(200);
		$("html, body").addClass("disable-scroll");

		var $loadOnOpen = $target.find(".js-popin-load-on-open");
		if($loadOnOpen.length > 0){
			this.loadOnOpen($loadOnOpen);
		}
	},

    popinUpdateAjax: function(e) {
    	e.preventDefault();
		let $this = $(e.currentTarget);
		let target = $this.attr('data-target-ajax-popin');
		let $loadOnOpen = $this.closest(".js-popin-load-on-open");
		var ajaxTargetUrl = $loadOnOpen.attr("data-ajaxUrl", target);
		this.loadOnOpen($loadOnOpen);
    },

    loadOnOpen: function($loadOnOpen) {
		var ajaxTargetUrl = $loadOnOpen.attr("data-ajaxUrl");
		$loadOnOpen.find(".js-popin-remove-on-close-content").html('');
		$loadOnOpen.find(".js-popin-load-on-open-loader").addClass("active");
	
		if(window.currentajax){// si requete en cours, on l'annule et la remplace par la nouvelle
			window.currentajax.abort();
		}
		// post or get
		window.currentajax = $.get(
			ajaxTargetUrl,
			function(response){}
		).done(function(response) {
			if(response.form){
				$loadOnOpen.find(".js-popin-load-on-open-content").html("").append($(response.form));
				if($loadOnOpen.find(".js-popinProductPreview")){
					popinProductPreview.init();
				}
			}else{
				$loadOnOpen.find(".js-popin-load-on-open-content").html("error");
			}
		})
		.fail(function(response) {
			$loadOnOpen.find(".js-popin-load-on-open-content").html("error");
		})
		.always(function(response) {
			$loadOnOpen.find(".js-popin-load-on-open-loader").removeClass("active");
		});
    },

    popinClose: function(e) {
		let self = this;
		let $this = $(e.target);
		let $targetPopin;
		e.stopPropagation();
		
		if($this.hasClass("js-popin")){
			$targetPopin = $this;
		} else {
			$targetPopin = $this.closest('.js-popin');
		}
		$targetPopin.fadeOut(200)
		$("html, body").removeClass("disable-scroll");

		var $removeOnClose = $targetPopin.find(".js-popin-remove-on-close-content");
		if($removeOnClose.length > 0){
			this.removeOnClose($removeOnClose);
		}
    },

	removeOnClose: function ($removeOnClose){
		$removeOnClose.html("")
	}

};

module.exports = popin;
